import { ETLListResponse, ETLRunRequest, ETLRunResponse } from '@/types/service/etl';

import { baseProtectedApi } from '@/store/baseApi';

export const etlApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableETLs: builder.query<ETLListResponse, void>({
      query: () => ({
        url: '/v1/protected/etl/available',
        method: 'GET',
      }),
    }),
    runETL: builder.mutation<ETLRunResponse, ETLRunRequest>({
      query: (data) => ({
        url: '/v1/protected/etl/run',
        method: 'POST',
        data: data,
      }),
    }),
  }),
});

export const { useGetAvailableETLsQuery, useRunETLMutation } = etlApi;
